
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XButton
},
name: "manage",
data() {
return {
height:window.innerHeight,
editStatus: false,
managerList:[]
}
},
methods:{
editStatusChange()
{
if (this.editStatus === true) {
this.editStatus = false
} else {
this.editStatus = true
}
},
addManager()
{
let shopId = this.$route.params.shopId
this.$router.push({
path: '/shop/'+ shopId +'/manage/manager/add'
})
},
editManager(id)
{
let shopId = this.$route.params.shopId
let path = ''
if (this.editStatus) {
path = '/shop/'+ shopId +'/manage/manager/'+ id +'/edit'
}else{
path = '/shop/'+ shopId +'/manage/manager/'+ id +'/detail'
}
this.$router.push({
path: path
})
},
queryOperatorList()
{
let _this = this;
let shopId = this.$route.params.shopId
let uri = '/v1/shop/'+ shopId +'/manage/operator/list';
_this.axios.get(uri, null, {
headers: {}
}).then(function (response) {
_this.managerList = response.data.data
}).catch(function (response) {
console.log(response);

});
}
},
created(){
this.queryOperatorList()
}
}



// WEBPACK FOOTER //
// ./src/components/manage/Manage.vue